// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3s6QM","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__L8Nm8"};